module.exports = __webpack_public_path__ + "static/media/mail.a02aab80.png";